const loadSliders = async ({ wrapper, loadSlider }) => {
  const sliders = [...wrapper.querySelectorAll('.slider--swiper')];
  await Promise.all(sliders.map((item) => loadSlider(item)));
};

const loadTabs = async ({ wrapper }) => {
  const tabs = [...wrapper.querySelectorAll('.tabs')];

  if (!tabs.length) {
    return;
  }

  const { default: Tabs } = await import(
    /* webpackChunkName: "modules_tabs" */ './modules/Tabs.js'
  );

  tabs.forEach((item) => Tabs.tabsInit(item));
};

const loadListrakForms = async ({ wrapper }) => {
  const forms = [...wrapper.querySelectorAll('.listrak_form')];

  if (!forms.length) {
    return;
  }

  const { default: ListrakForms } = await import(
    /* webpackChunkName: "modules_listrakForms" */ './modules/ListrakForms.js'
  );

  forms.forEach((item) => ListrakForms.init(item));
};

const loadVideos = async ({ wrapper }) => {
  const videos = [...wrapper.querySelectorAll('.gld-video-container, .gld-video')];

  if (!videos.length) {
    return;
  }

  const { default: Video } = await import(
    /* webpackChunkName: "modules_video" */ './modules/Video'
  );

  videos.forEach((item) => Video.initializePlayer(item));
};

const loadNewsletter = async ({ wrapper }) => {
  const forms = [...wrapper.querySelectorAll('form.newsletter')];

  if (!forms.length) {
    return;
  }

  const { default: Newsletter } = await import(
    /* webpackChunkName: "modules_newsletter" */ './modules/Newsletter.js'
  );

  forms.forEach((form) => new Newsletter(form));
};

const loadBootstrapCollapse = async () => {
  await import(
    /* webpackChunkName: "modules_bootstrap_collapse" */ './modules/Bootstrap/collapse'
  );
};

const lazySectionChunkLoaders = {
  'helpers/slider': loadSliders,
  'modules/tabs': loadTabs,
  'modules/listrakForms': loadListrakForms,
  'modules/ListrakForms': loadListrakForms,
  'modules/video': loadVideos,
  'modules/newsletter': loadNewsletter,
  'modules/Bootstrap/collapse': loadBootstrapCollapse,
};

export const loadLazySectionJSChunk = async (path, context) => {
  const loader = lazySectionChunkLoaders[path];

  if (!loader) {
    console.warn(`Lazy section JS chunk is not registered: ${path}`);
    return false;
  }

  await loader(context);
  return true;
};
